"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _utils = require("@trs/utils");
var _TablePagination = _interopRequireDefault(require("./TablePagination.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /*eslint-disable*/
var ICON_SIZE = 18;
var ITEMS_LIMIT = 100000;
var TablePagination = function TablePagination(_ref) {
  var currentPage = _ref.currentPage,
    totalResults = _ref.totalResults,
    resultsPerPage = _ref.resultsPerPage,
    onPageChange = _ref.onPageChange,
    isTableLoading = _ref.isTableLoading,
    disableLastPageArrow = _ref.disableLastPageArrow,
    otherProps = _ref.otherProps,
    tableFooterTracking = _ref.tableFooterTracking,
    withFormattedData = _ref.withFormattedData;
  return /*#__PURE__*/_react["default"].createElement(_TablePagination["default"], _extends({
    currentPage: currentPage,
    totalResults: totalResults,
    resultsPerPage: resultsPerPage,
    isTableLoading: isTableLoading,
    itemsLimit: ITEMS_LIMIT,
    disableLastPageArrow: disableLastPageArrow
  }, otherProps), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationFirst",
    className: "pagination-first",
    onClick: function onClick() {
      !isTableLoading && currentPage > 1 && onPageChange(1);
      if (!isTableLoading && currentPage > 1) tableFooterTracking.tablePaginationFirst();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-back",
    size: ICON_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-back",
    size: ICON_SIZE
  })), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationPrevious",
    className: "pagination-previous",
    onClick: function onClick() {
      !isTableLoading && currentPage > 1 && onPageChange(currentPage - 1);
      if (!isTableLoading && currentPage > 1) tableFooterTracking.tablePaginationPrev();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-back",
    size: ICON_SIZE
  })), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationStatus",
    className: "pagination-status"
  }, withFormattedData ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _utils.formatNumber)((currentPage - 1) * resultsPerPage + 1), " -", ' ', resultsPerPage <= totalResults && currentPage * resultsPerPage < totalResults ? (0, _utils.formatNumber)(currentPage * resultsPerPage) : (0, _utils.formatNumber)(totalResults), ' ', "/ ", (0, _utils.formatNumber)(totalResults)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (currentPage - 1) * resultsPerPage + 1, " -", ' ', resultsPerPage <= totalResults && currentPage * resultsPerPage < totalResults ? currentPage * resultsPerPage : totalResults, ' ', "/ ", totalResults)), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationNext",
    className: "pagination-next",
    onClick: function onClick() {
      !isTableLoading && Math.ceil(totalResults / resultsPerPage) > currentPage && onPageChange(currentPage + 1);
      if (!isTableLoading && Math.ceil(totalResults / resultsPerPage) > currentPage) tableFooterTracking.tablePaginationNext();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-forward",
    size: ICON_SIZE
  })), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationLast",
    className: "pagination-last",
    onClick: function onClick() {
      if (isTableLoading) return;
      var hasNextPage = Math.ceil(totalResults / resultsPerPage) > currentPage;
      if (disableLastPageArrow && hasNextPage && totalResults < ITEMS_LIMIT || !disableLastPageArrow && hasNextPage) {
        tableFooterTracking.tablePaginationLast();
        onPageChange(totalResults % resultsPerPage === 0 ? totalResults / resultsPerPage : Math.floor(totalResults / resultsPerPage) + 1);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-forward",
    size: ICON_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-forward",
    size: ICON_SIZE
  })));
};
TablePagination.defaultProps = {
  isTableLoading: false,
  tableFooterTracking: {
    tablePaginationFirst: function tablePaginationFirst() {},
    tablePaginationPrev: function tablePaginationPrev() {},
    tablePaginationNext: function tablePaginationNext() {},
    tablePaginationLast: function tablePaginationLast() {}
  }
};
TablePagination.propTypes = {
  tableFooterTracking: _propTypes["default"].shape({
    tablePaginationFirst: _propTypes["default"].func,
    tablePaginationPrev: _propTypes["default"].func,
    tablePaginationNext: _propTypes["default"].func,
    tablePaginationLast: _propTypes["default"].func
  }),
  currentPage: _propTypes["default"].number.isRequired,
  totalResults: _propTypes["default"].number.isRequired,
  resultsPerPage: _propTypes["default"].number.isRequired,
  onPageChange: _propTypes["default"].func.isRequired,
  isTableLoading: _propTypes["default"].bool,
  disableLastPageArrow: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = TablePagination;